import { TrustsDTO } from '../../../../../../api/useTrustsQuery';
import { useBeneficiaryFieldArray } from './hooks/useBeneficiaryFieldArray';

interface UseBeneficiariesOptionsParams {
  data: TrustsDTO;
}

export const useBeneficiaries = ({ data }: UseBeneficiariesOptionsParams) => {
  const primaryBeneficiariesFieldArray = useBeneficiaryFieldArray({
    fieldName: 'beneficiaries.primary',
  });

  const contingentBeneficiariesFieldArray = useBeneficiaryFieldArray({
    fieldName: 'beneficiaries.contingent',
  });

  const beneficiariesFields = [
    ...primaryBeneficiariesFieldArray.fields,
    ...contingentBeneficiariesFieldArray.fields,
  ];

  const beneficiariesOptions = data.BeneficiariesOptions.reduce<{ label: string; value: string }[]>(
    (acc, beneficiary) => {
      if (!beneficiariesFields.find(({ id }) => beneficiary.Id === id)) {
        acc.push({
          label: beneficiary.Name,
          value: beneficiary.Id,
        });
      }

      return acc;
    },
    [],
  );

  return {
    beneficiariesOptions,
    primaryBeneficiariesFieldArray,
    contingentBeneficiariesFieldArray,
  };
};
